export const environment = {
    production: true,
    envName: 'test_aecfa',
    baseBackUrl: 'https://cronoss-test.aecfa.es/',
    availableDomains: [
        'cronoss-test.aecfa.es'
    ],
    security: true,
    logLevel: 'DEBUG',
    httpTimeOut: 340000,
    dateFormat: 'dd/MM/yyyy',
    timeFormat: 'HH:mm',
    apiDateFormat: 'y-MM-dd',
    apiTimeFormat: 'HH:mm',
    fullDateTimeFormat: 'EEEE, d, MMMM, y, HH:mm',
    helpReactionTime: 300,
    visualFacility: false,
    version: '2.15.08',
    tryExpiration: 120
};